import { useQueryClient } from '@tanstack/react-query';
import type { CompanyProfile } from '@coreledger/shared-types';

/**
 * Returns true when the company's natureOfBusiness is 'transport'.
 * Reads from the cached ['company-profile'] query populated by AppShell,
 * so it never makes an extra network request.
 */
export function useIsTransport(): boolean {
  const qc = useQueryClient();
  const profile = qc.getQueryData<CompanyProfile>(['company-profile']);
  return profile?.natureOfBusiness === 'transport';
}
